import RoleHome from '../../components/RoleHome/RoleHome';
export default function DispatcherHome() {
  return <RoleHome role="dispatcher" />;
}